import React, { useState, useEffect } from "react";
import { Card, Grid, Sticky, Button, Form, Icon, Modal, Loader, Dimmer, Segment } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import "../css/Events.css";
import "../css/CreateEvent.css";
import "../css/Register.css";
import DateTimePicker from "react-datetime-picker";
import MapPicker from "react-google-map-picker";
import Geocode from "react-geocode";

export default function CreateEvent() {
    // This is a debug useState for the selector
    const [typeNameDisplay, setTypeNameDisplay] = useState();
    const [startValue, setStartValue] = useState(new Date());
    const [endValue, setEndValue] = useState(new Date());
    // event_name
    const [eventName, setEventName] = useState();
    // typeOfEvent
    const [eventTypeSelected, setEventTypeSelected] = useState();
    //  phone_no
    const [eventPhone, setEventPhone] = useState();
    // email
    const [eventEmail, setEventEmail] = useState();
    // rsoid
    const [eventRSO, setEventRSO] = useState(0);
    // description
    const [eventDescription, setEventDescription] = useState();
    // eventDate (need 2 useStates cause there is 2 different date time picker we need to check that they are the same date)
    const [eventStartDate, setEventStartDate] = useState();
    const [eventEndDate, setEventEndDate] = useState();
    // start
    const [eventStartTime, setEventStartTime] = useState();
    const [eventStartValue, setEventStartValue] = useState();
    // end
    const [eventEndTime, setEventEndTime] = useState();
    const [eventEndValue, setEventEndValue] = useState();
    // category
    const [eventCategorySelected, setEventCategorySelected] = useState();
    // lname
    const [eventLocationName, setEventLocationName] = useState();
    // longitude
    const [eventLat, setEventLat] = useState(28.6024274);
    // latitude
    const [eventLng, setEventLng] = useState(-81.2000599);
    // address
    const [eventAddress, setEventAddress] = useState();

    const [dateError, setDateError] = useState(false);

    const [timeError, setTimeError] = useState(false);

    const [RSOError, setRSOError] = useState(false);

    const [overlapError, setOverlapError] = useState(false);

    const [locationError, setLocationError] = useState(false);

    const [eventTypeOption, setEventTypeOption] = useState([
        { text: "Public", value: 0, id: 0 },
        { text: "Private", value: 1, id: 1 },
        { text: "RSO", value: 2, id: 2 },
    ]);

    const [eventCategoryOption, setEventCategoryOption] = useState([
        { text: "Academic", value: 0, id: 0 },
        { text: "Social", value: 1, id: 1 },
        { text: "RSO", value: 2, id: 2 },
    ]);

    const [eventRSOOption, setEventRSOOption] = useState([]);

    const [defaultLocation, setDefaultLocation] = useState({
        lat: 28.6024274,
        lng: -81.2000599,
    });

    const [zoom, setZoom] = useState(16);

    const [RSOOwnList, setRSOOwnList] = useState([]);

    const [displayRSOList, setDisplayRSOList] = useState(false);

    const [displayModal, setDisplayModal] = useState(false);

    const map = document.getElementsByClassName("mappicker");

    let navigate = useNavigate();

    useEffect(() => {
        // Don't need to if statement, just the stuff code in the if statement
        if (map.length > 0) {
            setTimeout(() => {
                Geocode.setApiKey("AIzaSyCiA-Lw4YtdQcrQuqNcscM5II9082B5m6k");

                Geocode.fromLatLng(
                    defaultLocation.lat,
                    defaultLocation.lng
                ).then(
                    (response) => {
                        const address = response.results[0].formatted_address;
                        console.log(address);
                        setEventAddress(address);
                    },
                    (error) => {
                        console.error(error);
                    }
                );

                // handleGetStartDate(startValue);
                // handleGetEndDate(endValue);
                handleGetRSOOwned();
            }, 1000);
            // handleGetStartDate(startValue);
            // handleGetEndDate(endValue);
        }
    }, []);

    useEffect(() => {
        console.log(RSOOwnList);
    }, [RSOOwnList]);

    useEffect(() => {
        // console.log(eventTypeSelected);
        console.log(eventTypeSelected + 100);
        console.log(typeof eventTypeSelected);
        // console.log("");

        if (eventTypeSelected == 2) {
            setDisplayRSOList(true);
            setEventRSO(0);
            setRSOError(true);
        } else {
            setDisplayRSOList(false);
            setEventRSO(0);
            setRSOError(false);
        }
    }, [eventTypeSelected]);

    useEffect(() => {
        if (eventStartValue >= eventEndValue) {
            setTimeError(true);
        } else {
            setTimeError(false);
        }

        setOverlapError(false);
    }, [eventStartValue, eventEndValue]);

    useEffect(() => {
        console.log("Start");
        console.log(eventStartDate);
        console.log("End");
        console.log(eventEndDate);
        console.log(eventStartDate != eventEndDate);
        setDateError(eventStartDate != eventEndDate);
    }, [eventStartDate, eventEndDate]);

    useEffect(() => {
        console.log("Lat: " + eventLat);
        console.log("Lng: " + eventLng);
    }, [eventLat, eventLng]);

    useEffect(() => {
        if (eventTypeSelected == 2) {
            if (eventRSO > 0) {
                setRSOError(false);
            } else {
                setRSOError(true);
            }
        } else {
            setRSOError(false);
        }
    }, [eventRSO]);

    useEffect(() => {
        setLocationError(false);
    }, [eventLocationName]);

    // useEffect(() => {
    //     console.log(RSOOwnList);
    // }, [RSOOwnList]);

    // useEffect(() => {
    //     console.log(eventCategorySelected);
    // }, [eventCategorySelected]);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectMyRSO = () => {
        navigate("/MyRSOs");
    };

    const redirectEvent = () => {
        navigate("/Events");
    };

    const handleGetEventName = (e) => {
        setEventName(e.target.value);
        console.log(eventName);
    };

    const handleGetEventType = (e, data) => {
        console.log(data.value);
        setTypeNameDisplay(e.target.innerText);
        setEventTypeSelected(Number(data.value));
        setEventTypeSelected(Number(data.value));
    };

    const handleGetEventCategory = (e, data) => {
        setEventCategorySelected(Number(data.value));
        setEventCategorySelected(Number(data.value));
    };

    const handleGetPhone = (e) => {
        setEventPhone(e.target.value);
        console.log(eventPhone);
    };

    const handleGetEmail = (e) => {
        setEventEmail(e.target.value);
        console.log(eventEmail);
    };

    const handleGetDescription = (e) => {
        setEventDescription(e.target.value);
        console.log(eventDescription);
    };

    const handleGetStartDate = (e) => {
        // Format the string to something easier to parse
        let date = new Date(e.target.value);
        console.log(date);
        console.log(typeof date);
        setStartValue(date);
        let dateTimeArray = date.toLocaleString().split(" ");

        // Get the only date substring
        // We have to get rid of the extra comma at the end
        dateTimeArray[0] = dateTimeArray[0].substring(
            0,
            dateTimeArray[0].length - 1
        );

        // Split the time string so we can get rid of the seconds and append AM/PM
        let timeArray = dateTimeArray[1].split(":");
        dateTimeArray[1] = timeArray[0] + ":" + timeArray[1] + dateTimeArray[2];

        // Get rid of the extra AM/PM element
        dateTimeArray.pop();

        setEventStartDate(dateTimeArray[0]);
        setEventStartTime(dateTimeArray[1]);
        setEventStartValue(date.valueOf());
        // console.log(eventStartDate);
    };

    

    const handleGetEndDate = (e) => {
        // Format the string to something easier to parse
        let date = new Date(e.target.value);
        console.log(date);
        console.log(typeof date);
        setEndValue(date);
        let dateTimeArray = date.toLocaleString().split(" ");

        // Get the only date substring
        // We have to get rid of the extra comma at the end
        dateTimeArray[0] = dateTimeArray[0].substring(
            0,
            dateTimeArray[0].length - 1
        );

        // Split the time string so we can get rid of the seconds and append AM/PM
        let timeArray = dateTimeArray[1].split(":");
        dateTimeArray[1] = timeArray[0] + ":" + timeArray[1] + dateTimeArray[2];

        // Get rid of the extra AM/PM element
        dateTimeArray.pop();

        setEventEndDate(dateTimeArray[0]);
        setEventEndTime(dateTimeArray[1]);
        setEventEndValue(date.valueOf());
        // console.log(eventStartDate);
    };

    const handleChangeLocation = (lat, lng) => {
        setEventLat(lat);
        setEventLng(lng);

        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                const address = response.results[0].formatted_address;
                console.log(address);
                setEventAddress(address);
            },
            (error) => {
                console.error(error);
            }
        );
    };

    const handleGetRSO = (e, data) => {
        setEventRSO(data.value);
    };

    const handleGetLocationName = (e) => {
        setEventLocationName(e.target.value);
        console.log(eventLocationName);
    }

    const printForm = () => {
        console.log(eventName);
        console.log(eventTypeSelected);
        console.log(eventPhone);
        console.log(eventEmail);
        console.log(eventRSO);
        console.log(eventDescription);
        console.log(eventStartDate);
        console.log(eventEndDate);
        console.log(eventStartTime);
        console.log(eventStartValue);
        console.log(eventEndTime);
        console.log(eventEndValue);
        console.log(eventCategorySelected);
        console.log(eventLat);
        console.log(eventLng);
        console.log(eventAddress);
    };

    async function handleGetRSOOwned() {
        try {
            // To debug/test, the json must explicitly be given the userid instead of getting it from storage (since you probably won't have a userid to get since there isn't a user signed in because you are testing)
            // let info = {
            //     userid: localStorage.getItem("userid"),
            // };

            let info = {
                userid: localStorage.getItem("userid"),
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listOwnedRSOs.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                console.log(res.results);
                for (let i = 0; i < res.results.length; i++) {
                    console.log(res.results[i]);

                    if (res.results[i].approval === 1) {
                        setRSOOwnList((prevState) => [
                            ...prevState,
                            {
                                text: res.results[i].name,
                                value: res.results[i].rsoid,
                                id: res.results[i].rsoid,
                            },
                        ]);
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSubmit() {
        try {
            // let info = {
            //     userid: 94,
            //     rsoid: eventRSO,
            //     typeOfEvent: eventTypeSelected,
            //     address: eventAddress,
            //     event_name: eventName,
            //     description: eventDescription,
            //     eventDate: eventStartDate,
            //     start: eventStartTime,
            //     end: eventEndTime,
            //     startValue: eventStartValue,
            //     endValue: eventEndValue,
            //     phone_no: eventPhone,
            //     email: eventEmail,
            //     category: eventCategorySelected,
            //     longitude: eventLng,
            //     latitude: eventLat,
            //     lname: " "
            // };

            // let info = {
            //   "userid": 94,
            //   "rsoid": 14,
            //   "typeOfEvent": 0,
            //   "address": "idk",
            //   "event_name": "Jojo Kat Frontend Check",
            //   "description": "Cool",
            //   "eventDate": "2022-03-28",
            //   "start": "01:16AM",
            //   "end": "02:16PM",
            //   "startValue": 600,
            //   "endValue": 601,
            //   "phone_no": "12345678",
            //   "email": "example@gmail.com",
            //   "category": 1,
            //   "lname": "location",
            //   "longitude": 28.60523820539147,
            //   "latitude": -81.20529758365383
            // }

            let info = {
              "userid": localStorage.getItem("userid"),
              "rsoid": eventRSO,
              "typeOfEvent": eventTypeSelected,
              "address": eventAddress,
              "event_name": eventName,
              "description": eventDescription,
              "eventDate": eventStartDate,
              "start": eventStartTime,
              "end": eventEndTime,
              "startValue": eventStartValue,
              "endValue": eventEndValue,
              "phone_no": eventPhone,
              "email": eventEmail,
              "category": eventCategorySelected,
              "lname": eventLocationName,
              "longitude": eventLat,
              "latitude": eventLng
            }

            console.log(info);

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/createEvent.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log(res);

            if (res.error === "Overlapping with another event") {
                setOverlapError(true);
            } 
            else if (res.error === "Location name already exists.")
            {
                setLocationError(true);
            }
            else {
                console.log("This is the response error: " + res.error);
                setDisplayModal(true);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem("first")}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectMyRSO}>My RSOs</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        <Icon className="event-icon" name='sign-out' size='large' />
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <h2 className="events-title">Create Event</h2>
                    <div className="events-create-event-container">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group>
                                <Form.Input
                                    fluid
                                    placeholder="Event Name"
                                    required
                                    onChange={handleGetEventName}
                                    width={9}
                                />
                                <Form.Select
                                    required
                                    fluid
                                    options={eventTypeOption}
                                    placeholder="Select Event Type"
                                    onChange={handleGetEventType}
                                    width={3}
                                />
                                <Form.Select
                                    required
                                    fluid
                                    options={eventCategoryOption}
                                    placeholder="Select Event Category"
                                    onChange={handleGetEventCategory}
                                    width={4}
                                />
                            </Form.Group>
                            {displayRSOList && (
                                <Form.Group>
                                    <Form.Select
                                        required
                                        fluid
                                        options={RSOOwnList}
                                        placeholder="Select RSO"
                                        onChange={handleGetRSO}
                                        width={16}
                                    />
                                </Form.Group>
                            )}
                            <Form.Group>
                                <Form.Input
                                    fluid
                                    placeholder="Contact Phone Number"
                                    required
                                    onChange={handleGetPhone}
                                    width={6}
                                />
                                <Form.Input
                                    fluid
                                    placeholder="Contact Email"
                                    required
                                    onChange={handleGetEmail}
                                    width={10}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.TextArea
                                    fluid
                                    placeholder="Description of Event"
                                    width={16}
                                    onChange={handleGetDescription}
                                />
                            </Form.Group>
                                <Grid columns={2}>
                                    <Grid.Column>
                                        <div className="events-picker">
                                            <h3>Start Time</h3>
                                            <input type="datetime-local" onChange={handleGetStartDate} required
                                            />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div className="createevent-datetime">
                                            <h3>End Time</h3>
                                            <input type="datetime-local" onChange={handleGetEndDate} required
                                            />
                                        </div>
                                    </Grid.Column>
                                </Grid>
                                <h3>Event Location</h3>
                                <Form.Input 
                                    fluid
                                    placeholder="Location Name"
                                    required
                                    onChange={handleGetLocationName}
                                    width={16}
                                />
                                <Form.Group width={16}>
                                    <div className="mappicker">
                                        <MapPicker
                                            className="create-event-map"
                                            defaultLocation={defaultLocation}
                                            zoom={zoom}
                                            apiKey="AIzaSyCiA-Lw4YtdQcrQuqNcscM5II9082B5m6k"
                                            onChangeLocation={handleChangeLocation}
                                        />
                                    </div>
                                </Form.Group>
                            {dateError && (
                                <div className="createevent-dateerror-container">
                                    <p className="createevent-dateerror">
                                        Please set the date for both start and
                                        end as the same
                                    </p>
                                </div>
                            )}
                            {RSOError && (
                                <div className="createevent-dateerror-container">
                                    <p className="createevent-dateerror">
                                        Please select an RSO if the event is of
                                        type RSO
                                    </p>
                                </div>
                            )}
                            {timeError && (
                                <div className="createevent-dateerror-container">
                                    <p className="createevent-dateerror">
                                        Please set the end time value greater
                                        than the start time value
                                    </p>
                                </div>
                            )}
                            {overlapError && (
                                <div className="createevent-dateerror-container">
                                    <p className="createevent-dateerror">
                                        Please select a different date and time for the event. The current date and time conflicts with a different event already made.
                                    </p>
                                </div>
                            )}
                            {locationError && (
                                <div className="createevent-dateerror-container">
                                    <p className="createevent-dateerror">
                                        Please give a new location name. The current location name is already used for a different address
                                    </p>
                                </div>
                            )}
                            <Form.Button className="createevent-button"
                            disabled={dateError || timeError || RSOError || overlapError || locationError}>
                                CREATE
                            </Form.Button>
                        </Form> 
                    </div>
                </div>
                <Modal open={displayModal}>
                    <Modal.Header>Event Created</Modal.Header>
                    <Modal.Content>
                        <p>You will be redirected to the event page</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="black" onClick={() => navigate("/Events")}>OK</Button>
                    </Modal.Actions>
                </Modal>
            </div>
        </div>
    );
}
